<mat-card class="mat-mdc-elevation-specific mat-elevation-z0 rounded-lg">
    <mat-card-content class="px-md-5">
        @if (mode === accountModeType.Phone) {
            <div class="h6 mb-5"
                 [innerHTML]="'auth.login.invitation_text.signInByPhone' | translate"></div>
        }

        @if (mode === accountModeType.Email) {
            <div class="h6 mb-5"
                 [innerHTML]="'auth.login.invitation_text.signInByEmail' | translate"></div>
        }

        <app-form-error class="d-block mb-3" [error]="error" />

        <form class="login-form" [formGroup]="form">
            @if (settings?.CLIENT_ATTR_EMAIL && settings?.CLIENT_ATTR_EMAIL === 'M') {
                <app-account-mode-switcher [mode]="mode"
                                           (setModeType)="handlerChangeMode($event)" />
            }

            @if (mode === accountModeType.Phone) {
                <div class="phone-field-container"
                     id="phone-field"
                     aria-labelledby="phone-field-tab">

                    <h2 class="visually-hidden">
                        {{ 'aria.head-auth-phone' | translate }}
                    </h2>

                    <app-country-selector [countryCodes]="countryCodes"
                                          [codeControl]="codeControl"
                                          (codeSelected)="onCodeSelect()" />

                    <mat-form-field class="phone-field">
                        <input matInput
                               type="text"
                               [placeholder]="'app.form.labels.phoneNumber' | translate"
                               maxlength="12"
                               minlength="5"
                               [formControlName]="loginFormField.Phone"
                               [imask]="{ mask: '000000000000' }"
                               autocomplete="tel-national"
                               #phoneInput
                               required />

                        @if (phoneControl.hasError('required')) {
                            <mat-error>
                                {{ 'auth.errors.phone_required' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            }

            @if (settings?.CLIENT_ATTR_EMAIL && settings?.CLIENT_ATTR_EMAIL === 'M' && mode === accountModeType.Email) {
                <mat-form-field class="email-field"
                                id="email-field"
                                tabindex="0"
                                aria-labelledby="email-field-tab">

                    <h2 class="visually-hidden">
                        {{ 'aria.head-auth-email' | translate }}
                    </h2>

                    <input matInput
                           type="text"
                           [placeholder]="'app.form.labels.email' | translate"
                           [formControlName]="loginFormField.Email"
                           required />

                    @if (emailControl.hasError('required')) {
                        <mat-error translate>auth.errors.email_required</mat-error>
                    }
                    @if (emailControl.hasError('pattern')) {
                        <mat-error translate>auth.errors.email_invalid</mat-error>
                    }
                </mat-form-field>
            }


            <mat-form-field class="password-field">
                <input matInput
                       [type]="hidePassword ? 'password' : 'text'"
                       maxlength="255"
                       minlength="4"
                       [placeholder]="'app.form.labels.password' | translate"
                       [formControlName]="loginFormField.Password"
                       autocomplete="current-password"
                       required />

                <mat-icon matSuffix
                          (click)="hidePassword = !hidePassword"
                          class="hide-password-icon"
                          [fontIcon]="hidePassword ? 'visibility_off' : 'visibility'" />

                @if (passwordControl.hasError('required')) {
                    <mat-error>
                        {{ 'auth.errors.password_required' | translate }}
                    </mat-error>
                }
                @if (passwordControl.hasError('minlength')) {
                    <mat-error>
                        {{ 'auth.errors.password_length' | translate: { length: passwordMinLengthLegacy } }}
                    </mat-error>
                }
            </mat-form-field>

            <div class="d-flex flex-nowrap justify-content-between align-items-center">
                <button color="primary"
                        mat-raised-button
                        id="loginButton"
                        [disabled]="form.invalid || pending"
                        (click)="onSubmit()">{{ 'app.actions.login' | translate }}
                </button>
                <div>
                    <a class="a--border-off"
                       [routerLink]="[routeEntity.Root, routeEntity.Recover]"
                       [attr.title]="'auth.login.recover_link' | translate"
                       tabindex="0">{{ 'auth.login.recover_link' | translate }}</a>

                </div>
            </div>
        </form>

        @if (enableGoogle) {
            <div class="d-flex flex-row align-items-center mt-3">
                <span class="me-3">{{ 'auth.login.oauthHead' | translate }}</span>
                <button mat-raised-button
                        [attr.aria-label]="'aria.loginByGoogle' | translate"
                        type="button"
                        (click)="signInByGoogle.emit();">
                    <img [attr.src]="'/assets/img/svg/google.svg'" width="24" height="24" />
                </button>
            </div>
        }
    </mat-card-content>
</mat-card>
